import {
    GetQuery,
    CreateQuery,
    generateUrlKey,
    setUrlInSession,
    langCheck,
    getWindow,
    getBreadCrumbInfo,
    getAutoFlag,
    isInsideTab,
    isValidString,
    isNestedWorkbench,
    cacheURL,
    getTopWorkbenchWin
} from "./utils";
import Browser from './browser';
import platform from "Pub/js/platform";
const { getLangCode, PubSub } = platform;
import { getStore, setStore } from "Pub/js/storageUtils";
import ModalOpenApp from "../../components/ModalOpenApp";
const IE_TABS_MAX = 5;

// workbench内置页面appcode
export const ownPageAppcodes = [
    "10181901", //企业风格设置-全局
    "10181902", //企业风格设置-集团
];
/**
 * 使用新标签打开页面
 * @param {Object} win 当前window对象
 * @param {String} pageUrl 跳转页面地址
 * @param {String} urlKey 页面唯一值
 * @param {Boolean} inNewTab 在新浏览器页签中打开
 */
export function commontOpenNewWindow() {
    getTopWorkbenchWin().commontOpenNewWindow(...arguments);
}
window.commontOpenNewWindow = function(win, pageUrl, urlKey, type = '', crossTabData, inNewTab, openParams = {}) {
    let tabInfo;
    if (type === 'modal') { // 弹窗打开
        const modalElement = document.createElement('div');
        modalElement.id = 'modal-open-app';
        document.querySelector('.nc-workbench-container').appendChild(modalElement);

        ReactDOM.render(<ModalOpenApp pageUrl={pageUrl} container={modalElement} />, modalElement);
        return;
    }
    // start-tab如果是false，浏览器页签打开
    if (isInsideTab()) { // 内部页签打开   
        let { ifr = '', n, b2, c } = GetQuery(pageUrl.split('#/')[1]);
        const hash = '#/?' + pageUrl.split('?')[1];
        // qiankun 默认iframe模式加载，乾坤暂停
        let microType = window.currentMicroAppType || 'iframe';
        const ifrQuery = GetQuery(ifr);
        // 将工作桌面内部页面当作节点的情况，使用iframe加载
        // 例：数据分析节点设置移动查询模板
        if (ifr.includes('workbench/public/common/main/index.html')) {
            microType = 'iframe';
        }

        // 工作桌面内部路由页面使用组件模式加载
        if (type === 'own' || ownPageAppcodes.includes(c)) {
            microType = 'component';
            ifr = pageUrl.match(new RegExp('(?<=#).*(?=[?])')).pop(); // 对应的路由
        }

        // 兼容一下tabName
        const name = ifrQuery.tabName || (isValidString(n) ? n : 'YonBIP');
        const { tabKey, tabConfig = {} } = openParams;
        const { mapDataFn, ...otherTabConfig } = tabConfig;

        // 页签唯一标识（linkto时会将原tabKey带过来直接用），打开之后这个值不能再次改变
        // 初始值用urlKey，通过这个key来判断页签是否存在（打开or定位）
        const initTabKey = tabKey || urlKey;
        const initAppInfo = GetQuery(`#/?page=${initTabKey}`);
        // 智能分析部件跳转没有携带c和p，获取appcode和pagecode兼容一下
        const { c: initC, p: initP, menucode, fifthmenucode, appcode, pagecode } = initAppInfo;
        const initAppData = { // 记录打开页签时初始应用的信息，右键打开新页签需要用到
            appcode: initC || appcode,
            pagecode: initP || pagecode,
            menuitemcode: fifthmenucode || menucode
        };
        const nowTime = Date.now();
        tabInfo = {
            ifr,
            name,
            // tipName: `${name}` + (isValidString(b2) ? `(${b2})` : ''),
            time: nowTime,
            key: initTabKey,
            appKey: urlKey,
            openType: type,
            hash,
            microType,
            appcode: c,
            extends: { isNewTab: ifrQuery.isNewTab },
            crossTabData,
            initAppData,
            mapDataFn
        };
        // 打开页签
        PubSub.publish('OpenTab', {
            tabInfo,
            inNewTab,
            tabConfig: otherTabConfig,
        });
        if (window.currentMicroAppType) { // 这个是为了兼容未适配内部页签的节点打开，临时变量，需要清空
            window.currentMicroAppType = null;
        }
        return;
    }
    //打开页面跳转逻辑
    openNewPage(win, pageUrl, urlKey, type, crossTabData);
}
export function openNewPage(win, pageUrl, urlKey, type, crossTabData) {
    let onBeforeOpenApp;
    if(window.WorkbenchCustomSetting && typeof window.WorkbenchCustomSetting.onBeforeOpenApp == "function"){
        onBeforeOpenApp = window.WorkbenchCustomSetting.onBeforeOpenApp;
        let storeUrl = cacheURL.getURL();
        let currentUrl = storeUrl[urlKey];
        let baseUrl = window.location.href.split('#')[0]
        let openUrl = baseUrl + '#/ifr?' + currentUrl;
        let isBeforeOpenApp = onBeforeOpenApp(openUrl);
        if(isBeforeOpenApp === false){
            return;
        }
    }
    let browser = Browser();
    let newWindowInstance;
    win = win ? win : window;
    if (type === 'current') {
        // bip 跳转到nc节点 在当前跳转页打开节点 不需要开新页面
        urlKey = '_self';
        win = win.top;
    }
    // 存local，然后跳转过去取出来
    if (crossTabData) {
        setStore('AppCrossTabData', {
            [urlKey]: crossTabData
        });
    }
    if (browser === 'Edge' || browser === 'Safari') {
        // Edge和Safari的隐身模式打开新窗口会拦截并只能保存当前的localStorage。会导致新页签无法获取到cowboy等localstorage数据
        // 只能采用a标签方式打开新页面
        // setAttribute 在生成的输出中嵌入了不可信任的数据。不可信任的数据直接嵌入输出，没有经过适当的净化或编码，这使攻击者能够将恶意代码注入输出。 
        let aEl = document.createElement('a');
        aEl.href = pageUrl;
        aEl.target = urlKey;
        aEl.id = 'new_tab_win_link';
        aEl.hidden = true;
        aEl.rel = 'opener';
        // aEl.setAttribute('href', pageUrl);
        // aEl.setAttribute('target', urlKey);
        // aEl.setAttribute('id', 'new_tab_win_link');
        // aEl.setAttribute('hidden', true);
        // aEl.setAttribute('rel', 'opener');
        if (document.getElementById('new_tab_win_link')) {
            document.body.removeChild(document.getElementById('new_tab_win_link'));
        }
        document.body.appendChild(aEl);
        setTimeout(() => {
            aEl.click();
        });
    } else { //其他非指定浏览器
        if (browser === 'IE') {//针对ie浏览器的处理，打开时查看记录的已打开数量,超过则给出提示
            let tabCnt = Number.parseInt(localStorage.getItem('ieTabCnt'));
            if (tabCnt == IE_TABS_MAX) {
                alert(langCheck("0000PUB-000467"));
            }
        }
        newWindowInstance = win.open(pageUrl, urlKey);
        //如果打开的页面手动修改url，再次跳转会切换到该页签，并不会打开新页签
        //利用try/catch触发跨域安全报错直接打开新页签
        try {
            if (newWindowInstance) {
                newWindowInstance.focus();
                //不打开新页签不同步sessionStorage 强制同步一下
                const curAPPUrl = win.sessionStorage.getItem('NCCAPPURL');
                // setTimeout(() => {
                // chrome.70版本打开节点白屏 NCC-211235，取sessionStorage导致的，加个延迟
                // newWindowInstance.sessionStorage.setItem('NCCAPPURL', curAPPUrl);
                // });
                // 采用postMessage方案，原因如上，加延迟，还是会偶发性打不开 NCC-211716
                newWindowInstance.postMessage({ type: 'updateAppUrl', data: curAPPUrl, crossTabData }, location.origin);
                newWindowInstance.crossTabData = crossTabData;
                // 不要清除下一个页签的NCCSessionStorage，下一个页签有可能是已打开的页签，里边存的是业务数据，不能清 NCC-357752
                // const autoFlag = getAutoFlag(); // 自动化环境flag
                // 自动化环境低版本的谷歌读sessionStorage会出错，先不管，后续看有啥好的解决方案
                // if (!autoFlag && clearNewPageSession) { // 从platform打开的需要保留，工作桌面打开的清除
                //     newWindowInstance.sessionStorage.removeItem('NCCSessionStorage'); // NCC-314139
                // }
            } else {
                if (browser === 'Firefox') { return; } // 火狐浏览器返回值是null，说明阻止了窗口打开，直接return，不要触发catch，否则会再次执行open导致提示阻止两个窗口
            }
            console.log(newWindowInstance.name); //为了触发error，不要删
        } catch (error) {
            win.open(pageUrl);
        }
    }
};
/**
 * 跳转方法
 * 包括 应用跳转、内部单页跳转
 */
/**
 * 应用打开
 * @param {Object} win - 当前window对象
 * @param {String} appcode - 应用编码
 * @param {String} appid - 应用主键
 * @param {String} pagecode - 应用编码
 * @param {Object} win -  新页面 window
 * @param {String} query - 需要传递的参数
 * @param {Object} appInfo - 应用信息
 * @param {Boolean} openTabWithoutCheck - 强制使用新窗口打开页面 默认false
 */
export const openApp = (
    win,
    appcode,
    appid,
    pagecode,
    type,
    query,
    appInfo,
    openTabWithoutCheck,
    queryParameters,
    pageParams,
    funcParams = {},
) => {
    /**
     * 应用信息
     * pageurl 页面url 地址
     * field 领域
     * module 模块
     * menuclass 菜单分类
     * menu 菜单
     */
    let {
        pageurl,
        menu: b4,
        menuclass: b3,
        module: b2,
        field: b1,
        is_sec_develop: sec_develop, //是否二开节点
    } = appInfo;
    // 打开新页面去重需求，需要每个页面都有同一个唯一name，所以需要把urlKey统一为appcode+pagecode组成页面的唯一串
    const { menucode } = appInfo;
    const {
        unique,
        tabConfig, // 内部页签配置，当前页签打开时的排序
    } = funcParams;
    let urlKey = generateUrlKey({ appcode, pagecode, menucode, unique: openTabWithoutCheck || unique });

    // 打开当前节点不做处理
    // 如果应用已经处于打开状态，将不往下执行，否则可能导致sessionStorage存的应用信息被重写
    if (isInsideTab()) {
        // 例：内部页签模式下，打开用户节点，新增进入卡片页面，此时sessionStroage的应用信息是卡片，此时如果再次打开用户，必须阻止，不然应用信息将重写为列表
        if (window.findAppInBrowserTabs(urlKey)) {
            return;
        }
    } else {
        const pageKey = "page=";
        if (location.hash.includes(pageKey)) {
            const pageStr = location.hash.split('page=').pop().split('&').shift();
            if (pageStr === urlKey) {
                return;
            }
        }
    }

    if (ownPageAppcodes.includes(appcode)) {
        type = "own";
    }
    appcode = encodeURIComponent(encodeURIComponent(appcode));
    pagecode = encodeURIComponent(encodeURIComponent(pagecode));
    appid = encodeURIComponent(encodeURIComponent(appid));
    let secDevelop = sec_develop ? `&sec_develop=Y` : ''; //如果是二开节点拼上此参数
    let langCode = getLangCode() ? `&lang=${getLangCode()}` : ''; //当前语种
    // 面包屑信息及应用编码
    let breadcrumbInfo = `&c=${appcode}&p=${pagecode}&ar=${appid}${langCode}${genBreadCrumbData(appInfo)}${secDevelop}`;
    // 参数
    let paramData;
    if (query && typeof (query) === 'string') {
        paramData = `&param=${encodeURIComponent(encodeURIComponent(query))}`;
    }
    if (type !== "own") {
        pageurl = encodeURIComponent(encodeURIComponent(pageurl));
        if (pageParams && typeof pageParams === 'object') {
            for (let k in pageParams) {
                if (pageParams[k]) {
                    pageurl += `&${k}=${pageParams[k]}`;
                }
            }
        }
    }
    let newUrl = '';
    if (win) {
        if (type !== "own") {
            let jumpUrl = '';
            // 浏览器新页签打开业务组应用
            if (HAS_WORKBENCH) {
                newUrl = paramData ? `ifr=${pageurl}${breadcrumbInfo}${paramData}` : `ifr=${pageurl}${breadcrumbInfo}`;
                jumpUrl = URL_IN_SESSION ? `#/ifr?page=${urlKey}` : `#/ifr?${newUrl}`;
                if (queryParameters) {
                    newUrl = `${newUrl}&queryParameters=${queryParameters}`;
                    jumpUrl = `${jumpUrl}`;
                    // jumpUrl = `${jumpUrl}&queryParameters=${queryParameters}`;
                }
                if (URL_IN_SESSION) { setUrlInSession(urlKey, newUrl); }
            } else {
                //这部分代码为了适配国产化系统性能问题去掉workbench的壳子，跳转单独做的处理
                pageurl = decodeURIComponent(decodeURIComponent(pageurl));
                let tmpUrl;
                //url有问号
                if (pageurl.indexOf('?') !== -1) {
                    tmpUrl = `${pageurl}${breadcrumbInfo}`;
                } else { //url没有问号
                    //url没有?有#
                    if (pageurl.indexOf('#') !== -1) {
                        tmpUrl = `${pageurl}?${breadcrumbInfo}`;
                    } else { //url没有?没有#
                        tmpUrl = `${pageurl}#/?${breadcrumbInfo}`;
                    }
                }
                let newPageUrl = paramData ? `${pageurl}${paramData}` : pageurl;
                newUrl = paramData ? `${tmpUrl}${paramData}` : tmpUrl;
                if (URL_IN_SESSION) {
                    //url没有?没有#
                    if (newPageUrl.indexOf('?') < 0 && newPageUrl.indexOf('#') < 0) {
                        jumpUrl = `${newPageUrl}#/?page=${urlKey}`;
                    } else {
                        jumpUrl = `${newPageUrl}?page=${urlKey}`;
                    }
                } else {
                    jumpUrl = newUrl;
                }
                if (URL_IN_SESSION) { setUrlInSession(urlKey, newUrl); }
            }
            commontOpenNewWindow(win, getAbsoluteUrl(jumpUrl), urlKey, type, null, openTabWithoutCheck, { tabConfig });
        } else {
            // 浏览器新页签打开workbench自有应用
            newUrl = `#/${pageurl}${breadcrumbInfo}`;
            let jumpUrl = URL_IN_SESSION ? `#/${pageurl}?page=${urlKey}` : newUrl;
            if (URL_IN_SESSION) { setUrlInSession(urlKey, newUrl); }
            commontOpenNewWindow(win, getAbsoluteUrl(jumpUrl), urlKey, type, null, openTabWithoutCheck, { tabConfig });
        }
    }
};

/**
 * workbench 内部页面跳转 页面级别 不包含 workbench内部应用
 *@param {String} router 目标路由
 *@param {Boolen} isNewTab 是否新页签打开 默认 false 当前页 true 新页签打开
 *@param {Object} query  需要传递的参数 面包屑参数 b1 > b2 > b3 > n
 *@param {Array} delKeys 需要删除的参数key数组
 */
export const openPage = (router, isNewTab, query, delKeys) => {
    // const isWorkbench = router.includes('workbenchid');
    let historyRouter = window.location.hash.split("?")[0].split("#/")[1];
    let isRefresh = false;
    if (!router.startsWith('/')) { // 兼容一下，移动模板设计器进来没有携带/
        router = `/${router}`;
    }
    router = '#' + router;
    // if (isWorkbench) { // 工作台设计/预览
    //     // 多个工作台数据会相互串（都是存store），该方案暂不采取
    //     commontOpenNewWindow(window, router, router.split('workbenchid=').pop().split('&').shift(), 'own');
    //     return;
    // }

    const urlKey = router.substring(2);
    // 兼容一下从领域节点跳workbench节点不刷新页面
    if (historyRouter == "ifr" && query && query._isRefresh === undefined) {
        isRefresh = true;
    }
    let newUri = {};
    let newUrl = '';
    if (query && JSON.stringify(query) != "{}") {
        let currentPageParams = {};
        if (query.joinCurrentPageParams) { // 拼接当前页面的参数，移动模板设置进设计器有用到
            delete query.joinCurrentPageParams;
            currentPageParams = GetQuery(window.location.hash);
        }
        newUri = { ...currentPageParams, ...query };
    }
    for (const key in newUri) {
        if (newUri.hasOwnProperty(key)) {
            // 删除指定的字段
            if (delKeys && delKeys.length > 0 && delKeys.indexOf(key) > -1) {
                delete newUri[key];
            } else {
                newUri[key] = encodeURIComponent(
                    encodeURIComponent(newUri[key]),
                );
            }
        }
    }
    let { defParam } = CreateQuery(newUri);

    newUrl = `${router}${defParam}`;
    const cacheUrl = cacheURL.getURL();
    const oldUrl = cacheUrl && [urlKey];
    let jumpUrl = URL_IN_SESSION ? `${router}${urlKey ? `?page=${urlKey}` : ''}` : newUrl;
    if (URL_IN_SESSION) { setUrlInSession(urlKey, newUrl); }

    // 新页签 或 内部页签
    if (isNewTab || isInsideTab()) {
        if (isInsideTab() && window.findAppInBrowserTabs(urlKey, newUrl !== oldUrl)) { // 已经打开，url不同时重载（目前适用场景是移动模板设置，设计时模板id不同的情况）
            return;
        }
        commontOpenNewWindow(window, getAbsoluteUrl(jumpUrl), urlKey, 'own');
    } else {
        window.name = urlKey;
        //判断有没有yonbip的iframe
        if (window.parent !== window) {
            getWindow().name = urlKey;
        }
        jumpWorkbenchPage(jumpUrl);
        // 刷新当前页打开
        if (isRefresh) {
            window.location.reload(true);
        }
    }
};

function jumpWorkbenchPage(jumpHash) {
    // 内部页签下先切视图再切路由，保证是可见状态
    isInsideTab() && PubSub.publish('OpenPage');
    window.location.hash = jumpHash;
}

//获取绝对路径
export function getAbsoluteUrl(pageUrl) {
    let href = getWindow().location.href;
    if (pageUrl.startsWith('http')) { return pageUrl; } //全路径直接返回
    //改成绝对路径
    if (pageUrl.indexOf('#/') != -1) {
        if (href.indexOf('#/') != -1) {
            href = href.substr(0, href.indexOf('#/'));
        }
        return href + pageUrl;
    }
    return pageUrl;
}

//生成面包屑数据
function genBreadCrumbData(appInfo) {
    let result = "",
        bcList = getBreadCrumbInfo(appInfo, true);
    for (const key in bcList) {
        result += `&${key}=${encodeURIComponent(encodeURIComponent(bcList[key]))}`; //两次转义
    }
    return result;
}

// //暂时没用先注掉
// //给bip发PostMessage消息打开bip的节点
// function sendBIPMesssage(win, { serviceCode }) {
//     win.postMessage(
//         JSON.stringify({
//             messType: "crossWindow",
//             eventType: "openService",
//             detail: {
//                 serviceCode,
//             },
//         }),
//         "*"
//     );
// }